import { memo } from 'react'

import { settingsModalUi } from '@/modals/SettingsModal'

export const Modals = memo(function Modals() {
  return <>{settingsModalUi}</>
})
